var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBootstrapColour(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 50 39.85",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    y1: 19.92,
    x2: 50,
    y2: 19.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5c4696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#574696"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#514696"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 12.94,
    y: 8.1,
    width: 25.36,
    height: 25.36
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29.05,15.07c0-2-1.39-3.05-3.83-3.05H20.74v6.33h3.78C27.44,18.35,29.05,17.17,29.05,15.07Zm16.32-1.14A28,28,0,0,1,44.5,5.2,5,5,0,0,0,39.64,0H10.38A5,5,0,0,0,5.52,5.2a28.32,28.32,0,0,1-.88,8.73c-.85,2.76-2.28,4.5-4.64,4.73v2.53c2.35.22,3.79,2,4.64,4.73a28,28,0,0,1,.88,8.72,5,5,0,0,0,4.86,5.21H39.63a5,5,0,0,0,4.86-5.21,28.27,28.27,0,0,1,.87-8.72c.86-2.76,2.29-4.51,4.64-4.73V18.66C47.66,18.43,46.22,16.69,45.37,13.93ZM26.09,30.52H17.38V9.32H26c3.85,0,6.38,2.09,6.38,5.29a4.73,4.73,0,0,1-3.87,4.61v.11a5.16,5.16,0,0,1,4.94,5.19C33.49,28.27,30.7,30.52,26.09,30.52Zm-.89-9.67H20.74v7h4.65c3,0,4.65-1.22,4.65-3.52S28.39,20.85,25.2,20.85Z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBootstrapColour);
export default __webpack_public_path__ + "static/media/Bootstrap_colour.792ba8bbb8fcd570828b47c82606948a.svg";
export { ForwardRef as ReactComponent };